/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Cyber: con 2 anillos en el carrito se agrega solo el anillo RAW de regalo (queda en $0 por el descuento automatico).
(function () {
  var RINGS = [10029229506809, 10029229572345, 10029229605113, 10029229637881, 10029229670649, 10029229703417];
  var GIFT_VARIANT = 67292021555449;
  var MIN_RINGS = 2;
  var OPT_OUT = 'lclz_raw_optout';

  function store(action, key, value) {
    try {
      if (action === 'get') return sessionStorage.getItem(key);
      if (action === 'set') sessionStorage.setItem(key, value);
      if (action === 'del') sessionStorage.removeItem(key);
    } catch (e) {}
    return null;
  }

  function countRings(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return RINGS.indexOf(item.product_id) !== -1 ? total + item.quantity : total;
    }, 0);
  }

  function giftLine(cart) {
    return ((cart && cart.items) || []).find(function (item) {
      return item.variant_id === GIFT_VARIANT;
    });
  }

  import('cart-store').then(function (module) {
    var Cart = module.default;
    var busy = false;
    var failed = false;
    var lastCart = null;

    async function run(action) {
      busy = true;
      try {
        await action();
      } catch (e) {
        failed = true;
      }
      busy = false;
      lastCart = Cart.getState().cart;
    }

    async function sync(cart) {
      if (busy || !cart || !cart.items) return;
      var prevCart = lastCart;
      lastCart = cart;
      var rings = countRings(cart);
      var gift = giftLine(cart);

      if (rings < MIN_RINGS) {
        store('del', OPT_OUT);
        failed = false;
        if (gift) await run(function () { return Cart.change({ id: gift.key, quantity: 0 }); });
        return;
      }

      if (!gift) {
        if (prevCart && giftLine(prevCart)) {
          store('set', OPT_OUT, '1');
          return;
        }
        if (failed || store('get', OPT_OUT) === '1') return;
        await run(function () { return Cart.add({ id: GIFT_VARIANT, quantity: 1 }); });
        return;
      }

      if (gift.quantity > 1) {
        await run(function () { return Cart.change({ id: gift.key, quantity: 1 }); });
      }
    }

    document.addEventListener('on:cart:loaded', function (event) {
      var cart = event.detail && event.detail.cart;
      setTimeout(function () { sync(cart); }, 50);
    });
    sync(Cart.getState().cart);
  });
})();

// Cyber: muestra el 20% de descuento ya aplicado en los anillos (precio tachado + precio final + etiqueta).
(function () {
  var HANDLES = ['anillo-localz', 'anillo-x-ensecreto', 'anillo-x-la-vikinga', 'anillo-x-michel-tumani', 'anillo-x-sotito', 'anillo-rootzy'];
  var DISCOUNT = 0.2;

  var style = document.createElement('style');
  style.textContent = '.lclz-off{display:inline-block;margin-left:8px;padding:2px 7px;font-size:0.7em;font-weight:700;line-height:1.4;letter-spacing:0.04em;background:#c00000;color:#fff;border-radius:3px;vertical-align:middle;text-transform:none!important}';
  document.head.appendChild(style);

  function handleFrom(href) {
    var match = /\/products\/([^/?#]+)/.exec(href || '');
    return match ? match[1] : null;
  }

  function handleOfPrice(priceEl) {
    if (priceEl.closest('interactive-cart, cart-items, .cart-item, .cart__items')) return null;
    if (priceEl.closest('.product-single')) return handleFrom(location.pathname);
    var node = priceEl.parentElement;
    for (var level = 0; node && level < 7; level++, node = node.parentElement) {
      var links = node.querySelectorAll('a[href*="/products/"]');
      if (!links.length) continue;
      var found = {};
      links.forEach(function (a) { var h = handleFrom(a.getAttribute('href')); if (h) found[h] = true; });
      var keys = Object.keys(found);
      return keys.length === 1 ? keys[0] : null;
    }
    return null;
  }

  function format(value, separator) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function decorate(priceEl) {
    if (priceEl.querySelector('.lclz-off') || priceEl.querySelector('.price__compare')) return;
    var number = priceEl.querySelector('.price__number');
    if (!number) return;
    var handle = handleOfPrice(priceEl);
    if (!handle || HANDLES.indexOf(handle) === -1) return;
    var money = number.querySelector('.money') || number;
    var original = money.textContent.trim();
    var digits = original.replace(/\D/g, '');
    if (!digits) return;
    var separator = /\d,\d{3}/.test(original) ? ',' : '.';
    var discounted = Math.round(parseInt(digits, 10) * (1 - DISCOUNT));
    money.textContent = original.replace(/\d[\d.,]*/, format(discounted, separator));
    number.classList.add('price__number--sale');
    var compare = document.createElement('s');
    compare.className = 'price__compare';
    compare.innerHTML = '<span class="money"></span>';
    compare.firstChild.textContent = original;
    number.insertAdjacentElement('afterend', compare);
    var badge = document.createElement('span');
    badge.className = 'lclz-off';
    badge.textContent = '-20%';
    compare.insertAdjacentElement('afterend', badge);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      document.querySelectorAll('.price').forEach(decorate);
    }, 60);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();

// Cyber: cuenta regresiva diaria hasta la medianoche (hora de Chile). Se reinicia cada dia.
(function () {
  var TZ = 'America/Santiago';

  var style = document.createElement('style');
  style.textContent =
    '.lclz-timer-bar{display:flex;justify-content:center;align-items:center;gap:10px;padding:8px 12px;background:#f0b94a;color:#141313;font-size:0.8rem;font-weight:700;letter-spacing:0.06em;text-align:center;text-transform:none!important}' +
    '.lclz-timer-bar b,.lclz-timer-box b{font-variant-numeric:tabular-nums;letter-spacing:0.08em}' +
    '.lclz-timer-box{margin:14px 0;padding:12px 14px;border:1px solid #f0b94a;background:#141313;color:#faf5f5;font-size:0.85rem;text-align:center;text-transform:none!important}' +
    '.lclz-timer-box b{color:#f0b94a;font-size:1.1em}';
  document.head.appendChild(style);

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function secondsLeft() {
    var h = 0, m = 0, s = 0;
    new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date())
      .forEach(function (part) {
        if (part.type === 'hour') h = parseInt(part.value, 10);
        if (part.type === 'minute') m = parseInt(part.value, 10);
        if (part.type === 'second') s = parseInt(part.value, 10);
      });
    return 86400 - (h * 3600 + m * 60 + s);
  }

  function tick() {
    var left = secondsLeft();
    var text = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
    document.querySelectorAll('[data-lclz-timer]').forEach(function (el) { el.textContent = text; });
  }

  function mount() {
    var container = document.querySelector('.page-container');
    if (container && !document.querySelector('.lclz-timer-bar')) {
      var bar = document.createElement('div');
      bar.className = 'lclz-timer-bar';
      bar.innerHTML = '<span>Oferta Cyber: termina hoy en</span><b data-lclz-timer>00:00:00</b>';
      container.insertBefore(bar, container.firstChild);
    }
    var price = document.querySelector('.product-single .price');
    if (price && !document.querySelector('.lclz-timer-box')) {
      var block = price.closest('.product-single__box__block') || price.parentElement;
      var box = document.createElement('div');
      box.className = 'lclz-timer-box';
      box.innerHTML = '<span>La oferta Cyber termina hoy en </span><b data-lclz-timer>00:00:00</b>';
      block.insertAdjacentElement('afterend', box);
    }
    tick();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  window.addEventListener('load', mount);
  setInterval(tick, 1000);
})();
